export default __webpack_public_path__ + "static/media/konto.7500b871.svg";